import ApiKey from '../service/service.config'

export default {
    createRequest: (method, data, recaptchToken) => {
        let request = {
            method: method,
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Key': ApiKey,
                'X-ReCAPTCHA-Token': recaptchToken
            }
        }

        if(data) {
            request.body = JSON.stringify(data);
        }

        if (recaptchToken) {
            request.headers['X-ReCAPTCHA-Token'] = recaptchToken;
        }

        return request;
    },
    handleResponse: async (response) => {
        if (response.status === 200 || response.status === 204) {
            try {
                return await response.json();
            }
            catch { }
        }

        return null;
    }
}